import * as React from 'react';

import './icon-styles.css';

export const CheckIcon = () => {
    return (
        <svg
            id="Layer_1"
            data-name="Layer 1"
            width="16"
            height="16"
            viewBox="0 0 16 16"
        >
            <clipPath id="clip-path">
                <rect className="icon-check-1" width="16" height="16" />
            </clipPath>
            <title>check</title>
            <g className="icon-check-2">
                <g className="icon-check-3">
                    <path
                        className="icon-check-4"
                        d="M11.63,5.29,7.94,10.71a.55.55,0,0,1-.43.24,1.24,1.24,0,0,1-.5-.18L4.86,8.62a.48.48,0,0,1,0-.56l.56-.55a.32.32,0,0,1,.49.06L7.32,9l3-4.5a.41.41,0,0,1,.49-.12l.62.43C11.69,4.92,11.76,5.11,11.63,5.29Z"
                    />
                    <rect
                        className="icon-check-5"
                        x="1.23"
                        y="1.23"
                        width="13.54"
                        height="13.54"
                        rx="2.46"
                    />
                </g>
            </g>
        </svg>
    );
};



// WEBPACK FOOTER //
// ./src/App/shared/icons/pt-icon-check.tsx